import { formatDate } from 'Helpers/date-utils';
import useMcHistory from 'Hooks/useMcHistory';
import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Segment } from 'semantic-ui-react';

import ContextMenuHeader from '../ContextMenuHeader';

import css from './McHistoryContextMenu.less';

const getCertName = cert => {
  return cert.certTypeName ?? cert.digiTypeInfo?.name;
};

// eslint-disable-next-line react/prop-types
const McHistoryContextMenu = ({ closeContextMenu }) => {
  const { mc, getHistoryMc } = useMcHistory();

  const { forPatientId } = useSelector(state => state.webChat.contextMenu.data, shallowEqual);

  useEffect(() => {
    if (forPatientId) getHistoryMc(forPatientId, { page: 1, pageSize: 1000 });
  }, [forPatientId, getHistoryMc]);

  return (
    <Segment.Group className="context-menu">
      <ContextMenuHeader
        title="All MC History"
        closeContextMenu={closeContextMenu}
        customClass="parent-menu"
      />
      <Segment className={css.list}>
        {mc.map(item => (
          <div key={item.id} className={css.historyItem}>
            <p className={css.type}>{getCertName(item)}</p>
            <p className={css.date}>{formatDate(item.startDate)}</p>
          </div>
        ))}
      </Segment>
    </Segment.Group>
  );
};

export default McHistoryContextMenu;
